import React from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily, dimensions } from "@Constants/baseStyles"
import Modal from "react-native-modal"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { RFValue } from "react-native-responsive-fontsize"
import SvgClose from "@Components/CustomIcon/SvgClose"
import styles from "./styles"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"

const ConsentementBeforeValidation = ({ canValidate, setCanValidate, isModalVisible, toggleModal }) => {
    const handleAuthorize = (value) => {
        console.log("🔁 Updating canValidate:", value)
        setCanValidate(value)
        toggleModal()
    }

    return (
        <Modal
            isVisible={isModalVisible}
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            swipeDirection={["left", "right", "down"]}
            onSwipeComplete={toggleModal}
            onBackButtonPress={toggleModal}
            style={{
                justifyContent: "flex-end",
                margin: 0
            }}
        >
            <View
                style={{
                    height: dimensions.fullHeight / 3,
                    backgroundColor: "#fff",
                    paddingHorizontal: 20,
                    paddingVertical: 25,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10
                }}
            >
                <TouchableOpacity
                    onPress={toggleModal}
                    style={{ flexDirection: "row", justifyContent: "flex-end", paddingRight: 10 }}
                >
                    <SvgClose height={15} width={15} />
                </TouchableOpacity>

                <BreeSerifText
                    fontSize={RFValue(20)}
                    style={{
                        textAlign: "center",
                        marginVertical: 10,
                        color: baseColors.orange.primary
                    }}
                >
                    Consentement
                </BreeSerifText>

                <ScrollView contentContainerStyle={{ paddingBottom: 20, paddingTop: 30 }}>
                    <View style={styles.secondCheckBoxContent}>
                        <CustomCheckBox
                            checked={canValidate}
                            handleCheck={handleAuthorize}
                            checkBoxColor={baseColors.green.primary}
                        />
                        <TouchableOpacity onPress={() => handleAuthorize(!canValidate)} style={{ flex: 1 }}>
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                style={{ flex: 1, paddingRight: 10 }}
                            >
                                J'autorise les soignants en charge de ce programme à accéder à mon dossier médical
                            </OpenSansText>
                        </TouchableOpacity>
                    </View>
                </ScrollView>
            </View>
        </Modal>
    )
}

export default ConsentementBeforeValidation
